import { axiosInstance } from "./apiClient";

export interface ToolOut {
  id: string;
  name: string;
  description: string;
  requires_grant: boolean;
}

export const toolsApi = {
  listAll: async (): Promise<ToolOut[]> => {
    const res = await axiosInstance.get("/tools");
    return res.data;
  },

  myTools: async (): Promise<string[]> => {
    const res = await axiosInstance.get("/me/tools");
    return res.data;
  },

  getUserTools: async (userId: string): Promise<string[]> => {
    const res = await axiosInstance.get(`/admin/users/${userId}/tools`);
    return res.data;
  },

  setUserTools: async (userId: string, tool_ids: string[]): Promise<string[]> => {
    const res = await axiosInstance.put(`/admin/users/${userId}/tools`, { tool_ids });
    return res.data;
  },
};
